export default "__VITE_ASSET__T6ItVg6T__"